// extracted by mini-css-extract-plugin
module.exports = {"item":"Accordion_item__4DQTW","icon":"Accordion_icon__bq7V3","mobileMenu":"Accordion_mobileMenu__ZIJXj","trigger":"Accordion_trigger__x6ef7","content":"Accordion_content__fHhhp"};